export default __webpack_public_path__ + "static/media/en.516897fd.svg";